import {CommitHash} from '@shared/dynamo_model';
import {EnvConstants} from '@shared/model/env_constants';

export const COMMIT_HASH = '834523033f97ddad78c3f0c90da1ff3ef51315ab' as CommitHash;
export const IS_LOCALHOST_ENV = false as boolean;
export const IS_DEVELOPMENT_ENV = false as boolean;
export const IS_PRODUCTION_ENV = true as boolean;
export const env: EnvConstants = {
  type: 'prod',
  region: 'eu-west-1',
  onescaleDomainName: 'onescale.io',
  cidrBlock: '10.3.0.0/16',
  accountId: 'azq3l25a765kd2ol',
  stripe: {
    apiPublishableKey:
      'pk_test_51NxCNdCS2V4e2nHuugzPMkQ0WiRwzwSt8fV1pEzZXhvzWKC7M77xwYpydzfOmcKMqNuGlSNy63GjPon8COGpiv7g0093rBjZcu',
    liveMode: false,
  },
  expertTicket: {
    baseUrl: 'https://api.portaventuraworld.experticket.com/api',
    partnerId: '8ja1sdeifghtc',
    apiVersion: '3.54',
  },
  googleMapsApiKey: 'AIzaSyDQ3VD_ybEGMknTAUxQNaIvVnxbbR45lPU',
} as EnvConstants;
